import {useMutation, useQuery} from "react-query"
import {mqttConnectivityAxios} from "lib/http/http.common"
import {ApiResponse} from "dto/ApiResponse"
import {FlowMapper} from "dto/FlowMapper"
import {queryClient} from "index"
import {map} from "react-sortable-tree"

// message-flow-mapper
const FindAllMessageFlowMappers = "findAllMessageFlowMappers"
const FindMessageFlowMapperById = "findMessageFlowMapperById"
export const useFindAllMessageFlowMappers = () => {
    return useQuery([FindAllMessageFlowMappers], async () => {
        const response = await mqttConnectivityAxios.get<ApiResponse<FlowMapper[]>>("/message-flow-mapper")
        return response.data?.body
    })
}

export const useFindMessageFlowMapperById = (id?: string) => {
    return useQuery([FindMessageFlowMapperById, id], async () => {
        const response = await mqttConnectivityAxios.get<ApiResponse<FlowMapper>>(`/message-flow-mapper/${id}`)
        return response.data?.body
    }, {
        enabled: !!id
    })
}

export const useRegisterMessageFlowMapper = () => {
    return useMutation(async (mapper: FlowMapper) => {
        await mqttConnectivityAxios.post("/message-flow-mapper", mapper)
        await queryClient.invalidateQueries(FindAllMessageFlowMappers)
    })
}

export const useUpdateMessageFlowMapper = () => {
    return useMutation(async (mapper: FlowMapper) => {
        await mqttConnectivityAxios.put(`/message-flow-mapper/${mapper.id}`, mapper)
        await queryClient.invalidateQueries(FindAllMessageFlowMappers)
        await queryClient.invalidateQueries([FindMessageFlowMapperById, mapper.id])
    })
}

export const useDeleteMessageFlowMapper = () => {
    return useMutation(async (id: string) => {
        await mqttConnectivityAxios.delete(`/message-flow-mapper/${id}`)
        await queryClient.invalidateQueries(FindAllMessageFlowMappers)
    })
}